export const SEARCH_START = 'SEARCH_START';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';

export const SEARCH_SELECT_ITEMS_START = 'SEARCH_SELECT_ITEMS_START';
export const SEARCH_SELECT_ITEMS_SUCCESS = 'SEARCH_SELECT_ITEMS_SUCCESS';
export const SEARCH_SELECT_ITEMS_FAILURE = 'SEARCH_SELECT_ITEMS_FAILURE';

export const SHOW_START = 'SHOW_START';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_FAILURE = 'SHOW_FAILURE';

export const RETRY_START = 'RETRY_START';
export const RETRY_SUCCESS = 'RETRY_SUCCESS';
export const RETRY_FAILURE = 'RETRY_FAILURE';

export const CSV_OUTPUT_START = 'CSV_OUTPUT_START';
export const CSV_OUTPUT_SUCCESS = 'CSV_OUTPUT_SUCCESS';
export const CSV_OUTPUT_FAILURE = 'CSV_OUTPUT_FAILURE';

export const CLEAR_ALL = 'CLEAR_ALL';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
